import { deviceTypes } from "../../enums/deviceTypes";
import { responsiveAction } from './responsive-slice';

export const checkWindowSize = () => (dispatch) => {

    const handleResize = () => {
        let newWindowSize;
        if (window.innerWidth > 1590) {
            newWindowSize = deviceTypes.columns4;
        }
        else
            if (window.innerWidth > 1310) {
                newWindowSize = deviceTypes.columns3;
            }
            else
                if (window.innerWidth > 880) {
                    newWindowSize = deviceTypes.columns2;
                }
                else
                    if (window.innerWidth > 600) {
                        newWindowSize = deviceTypes.tablet;
                    }
                    else {
                        newWindowSize = deviceTypes.mobile;
                    }
        dispatch(responsiveAction.setWindowSize(newWindowSize));
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => {
        window.removeEventListener('resize', handleResize);
    };
};